const PREFIX = '_auth_carespace';
export const STORAGE_KEY_CREDENTIALS = `${PREFIX}_credentials`;
export const STORAGE_KEY_USER = `${PREFIX}_user`;
export const STORAGE_KEY_TYPE = `${PREFIX}_type`;
export const STORAGE_KEY_TOKEN = `${PREFIX}_token`;
export const STORAGE_KEY_REFRESH_TOKEN = `${PREFIX}_refresh_token`;
export const EVENT_REFRESH_TOKEN = 'REFRESH_TOKEN';
